/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NewUserLandingPageQueryVariables = {||};
export type NewUserLandingPageQueryResponse = {|
  +newUserLandingPage: ?{|
    +newUserPortfolio: ?boolean
  |}
|};
export type NewUserLandingPageQuery = {|
  variables: NewUserLandingPageQueryVariables,
  response: NewUserLandingPageQueryResponse,
|};
*/


/*
query NewUserLandingPageQuery {
  newUserLandingPage {
    newUserPortfolio
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NewUserLandingPage",
    "kind": "LinkedField",
    "name": "newUserLandingPage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "newUserPortfolio",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NewUserLandingPageQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NewUserLandingPageQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "b0cec767dc77fe56407e701b4481a31b",
    "id": null,
    "metadata": {},
    "name": "NewUserLandingPageQuery",
    "operationKind": "query",
    "text": "query NewUserLandingPageQuery {\n  newUserLandingPage {\n    newUserPortfolio\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e5bd75df70a18c2ab58a4b9e0eb91591';

module.exports = node;
